<template>
  <div class="facebook-post-preview-header">
    <social-step-editor-main-avatar :profile="profile" />

    <div class="facebook-post-preview-header__data">
      <div class="facebook-post-preview-header__name">{{ profile ? profile.name : 'Sample Account' }}</div>
      <div class="facebook-post-preview-header__date">
        {{ today }}
        <img
          :src="`/wp-content/themes/snappy-theme/assets/images/builders/sponsored.svg`"
          class="facebook-post-preview-header__world"
          alt=""
        />
      </div>
    </div>
    <span v-html="dots" class="facebook-post-preview-header__dots"></span>
  </div>
</template>

<script>
import SocialStepEditorMainAvatar from '../shared/SocialStepEditorMainAvatar';
import {extractSocialPostStepPieces} from '../../mixins/extractSocialPostStepPieces.mixin';
import MoreDotsSvg from '!!raw-loader!../../../../../../../../assets/images/builders/dots.svg';

export default {
  mixins: [extractSocialPostStepPieces],
  components: {
    SocialStepEditorMainAvatar,
  },
  props: {
    pieces: Array,
    date: Number,
    profile: Object,
  },
  data() {
    return {
      dots: MoreDotsSvg,
    };
  },
  computed: {
    today() {
      return moment(new Date()).format('MMMM DD, YYYY');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../../../../../../sass/web/_variables';

.facebook-post-preview-header {
  padding: 20px 15px 10px;
  display: grid;
  grid-template-columns: min-content 1fr max-content;
  grid-template-rows: min-content;
  gap: 8px 14px;
  &__data {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
  }
  &__name {
    font-weight: bold;
    font-size: 16px;
    line-height: 19px;
    display: flex;
    color: $black-color;
  }
  &__date {
    font-size: 13px;
    color: $color-shuttle-grey;
    display: flex;
    align-items: center;
    gap: 5px;
  }
  &__world {
    height: 13px;
  }
  &__dots {
    align-self: flex-start;
    position: relative;
    right: 10px;
    top: -10px;
    transform: rotate(90deg) scale(2);
  }
  &__message {
    font-size: 15px;
    grid-column: 1/4;
    word-break: break-word;
    line-height: 1.33;
  }
}
</style>
